// extracted by mini-css-extract-plugin
module.exports = {"title":"SettungsInbox_title__2NEMJ","alert":"SettungsInbox_alert__YkIiz"};